import React, { useEffect, useState, PureComponent } from "react";
import moment from "moment";
import { Modal, Button, Tabs, Checkbox, TextBox, TextArea, IconWarningAlt, IconDownload } from "@veneer/core";
import SpecialConditionDetailTypes3_14 from "./SpecialConditionDetailTypes3_14";
import SpecialConditionDetailTypes4 from "./SpecialConditionDetailTypes_4";
import SpecialConditionDetailTypes2_12 from "./SpecialConditionDetailTypes2_12";
import SpecialConditionAdditionalInformation from "./SpecialConditionAdditionalInformation";
import SpecialConditionDetailTypes_7 from "./SpecialConditionDetailTypes_7";
import SpecialConditionDetailTypes_1 from "./SpecialConditionDetailTypes_1";
import SpecialConditionDetailTypes_16 from "./SpecialConditionDetailTypes_16";
import SpecialConditionDetailTypes_22 from "./SpecialConditionDetailTypes_22";
import SpecialConditionDetailTypes_21 from "./SpecialConditionDetailTypes_21";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, } from "recharts";
import Swal from "sweetalert2"
import { downloadFile } from "../../../services/FileDownloader/FileDownloader";

const connectApi = new ConnectAPI();

function SpecialConditionDetail({ idSpecialCondition, onShowModal, onCloseSCDetailsModal, SpecialConditionDetail, confirmationFunction, rejectSCFlow }) {
    const [t] = useTranslation();
    const [effectiveMonths, setEffectiveMonths] = useState(0)
    const [datahistory,setdatahistory]=useState([]);
    const [presses,setPresses]=useState([]);
    const [endDate, setEndDate] = useState("")
    const [strdupliciti, setstrdupliciti] = useState("")
    const [notesBoll, setNotesBoll]=useState(false);
    let specialConditionTypeId = SpecialConditionDetail.idSpecialConditionType;
    const [notes, setNotes]=useState("");
    const [moreSegment, setMoreSegment]=useState(false);
    const [currentUser, setCurrentUser]=useState({});

    // por el momento, despues eliminar esto y el boton 
    const downloadPdfFile = (status, data) => { downloadFile( "LetterCreateiPSP\\" + SpecialConditionDetail.customerName + "\\" + data[1] ); }
    const exportData = () => {
        let effective = "";
        if(effectiveMonths == 1) effective = effectiveMonths.toString() + ' Mes';
        else effective = effectiveMonths.toString() + ' Meses';

        let data={
            name: JSON.parse(localStorage.getItem("currentUser")).name,
            effective: effective,
            SpecialCondition:SpecialConditionDetail
        }
        connectApi.post('api/Channels/createPDFtoHTML', data, downloadPdfFile);
    };

    var lastday = function(y,m){
        return  new Date(y, m +1, 0).getDate();
    }

    const increaseEndDate = (e) => {
        let date = new Date(Date.parse(SpecialConditionDetail.startDate));
        date.setMonth(date.getMonth() + parseInt((e-1)));
        date.setDate(lastday(date.getFullYear(), date.getMonth()));
        setEndDate(date.getDate()+"/"+t('month' + (date.getMonth()+1).toString()) + "/"+date.getFullYear());
        SpecialConditionDetail.endDate=moment(date).format("DD/MMM/YYYY");
    }

    const get_history=()=>{
        connectApi.getWithParams("api/Channels/get_tpi_history",SpecialConditionDetail.idSpecialCondition , get_data_history)
        .catch((error) => {
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        })
    }
    const getSCDupliciti=()=>{
        if (SpecialConditionDetail.idSpecialCondition!==undefined){
            connectApi.getWithParams("api/Channels/getscdupliciti",SpecialConditionDetail , get_duplicitiSC)
            .catch((error) => {
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            })
        }
        
    }
    const get_duplicitiSC=(status,data)=>{
        setstrdupliciti(data);
    }
    const get_data_history=(status, data)=>{
        setdatahistory(data);
        let press=data.map(item=>item.idPress).filter(onlyUnique);
        setPresses(press)
    }
    useEffect(()=>{
        setCurrentUser(JSON.parse(localStorage.getItem("currentUser")));
        get_history();
        calc_initial_effectivemont();
        getSCDupliciti();
    },[SpecialConditionDetail.idSpecialCondition]);
    
    function calc_initial_effectivemont(){
        var initial=0;
        setEndDate(SpecialConditionDetail.endDate);
        var date_start = moment(SpecialConditionDetail.startDate);
        var date_end = moment(SpecialConditionDetail.endDate);
        initial=date_end.diff(date_start, 'months');
        initial=initial+1;
        setEffectiveMonths(initial);
    }

    function approveOrReject (flag){
        if(notes!=""){
            if(SpecialConditionDetail.notes!=""){
                if(!flag) SpecialConditionDetail.notes += ` \n;Reject:\n`;
                SpecialConditionDetail.notes += ` \n${currentUser.idUser}(${t('approvalLevel')}: ${SpecialConditionDetail.approvalLevel}): ${notes}`;
            }else{
                if(!flag) SpecialConditionDetail.notes = ` ;Reject:\n`;
                SpecialConditionDetail.notes += ` ${currentUser.idUser}(${t('approvalLevel')}: ${SpecialConditionDetail.approvalLevel}): ${notes}`;
            }
        }
        // Si es verdadera es aprovar, en caso de falso rechazar
        if(flag) confirmationFunction();
        else rejectSCFlow();
    }
   
    const specialConditionType = () => {
        //type 1: Maximum cost per print - type 13: Maximum CPP LS Mark
        if (specialConditionTypeId == 1 || specialConditionTypeId == 13 || specialConditionTypeId==26 || specialConditionTypeId==30) {
            return <SpecialConditionDetailTypes_1 specialCondition={SpecialConditionDetail} />
        } //type 15: Maximum Cost Per Print - XRate - type 18: Maximum CPP - Rebate
        if (specialConditionTypeId == 16 || specialConditionTypeId==18) {
            return <SpecialConditionDetailTypes_16 specialCondition={SpecialConditionDetail} />
        } //type 3: Fixed Bonus - type 14 Fixed Bonus + EPM
        if (specialConditionTypeId == 3 || specialConditionTypeId == 14 || specialConditionTypeId == 25) {
            return <SpecialConditionDetailTypes3_14 specialCondition={SpecialConditionDetail} />
        } //type 4: Tiers Up
        if (specialConditionTypeId == 4) {
            return <SpecialConditionDetailTypes4 specialCondition={SpecialConditionDetail} />
        } //type 2: Bonus Special Table - type 12: Bonus Special Table + EPM - type 15: Bonus Special Table - All Imp
        if (specialConditionTypeId == 2 || specialConditionTypeId == 12 || specialConditionTypeId == 15) {
            return <SpecialConditionDetailTypes2_12 specialCondition={SpecialConditionDetail}/>
        } //type 7: Combine clicks - type 17: Combine Clicks + Spl Tbl EPM - type 8: Combine Clicks + Special Table - type 19: Combine Clicks + Tiers Up
        if (specialConditionTypeId == 7 || specialConditionTypeId == 8 || specialConditionTypeId == 17 || specialConditionTypeId == 19) {
            return <SpecialConditionDetailTypes_7 specialCondition={SpecialConditionDetail} />
        } // Type 11 Minimum Discount
        if (specialConditionTypeId == 11) {
            return SpecialConditionDetail.Percentage;
        } //type 21: Run Length
        if (specialConditionTypeId == 21 ) {
            return <SpecialConditionDetailTypes_21 specialCondition={SpecialConditionDetail} />
        } //type 22: Maximum CPP - LS Discount - type 23: Low Coverage Program
        if (specialConditionTypeId == 22 || specialConditionTypeId == 23) {
            return <SpecialConditionDetailTypes_22 specialCondition={SpecialConditionDetail} />
        }
    }
    const datedupliciti=()=>{
        return ( <> {
            strdupliciti.split(',').map( (row) => {
                return (<>
                    { 
                        (!isNaN(row)===false) ?
                        ( <><IconWarningAlt filled color="colorYellow4" />{row},</> )
                        :( <><a href={'Cpp/SpecialConditionReport/' + row} target='blank_'>{row}</a>,</> )
                    }
                </>)
            })
        } </> );
    }
    const get_boolean_segment=(status, data)=>{
        setMoreSegment(data);
    }
    const morePressesFromTheSameSegment=()=>{
        if (SpecialConditionDetail.idSpecialCondition!==undefined){
            let params = SpecialConditionDetail.idSpecialCondition + "," + SpecialConditionDetail.idEndUser;
            connectApi.getWithParams("api/Channels/boolean_segment",params , get_boolean_segment).catch((error) => {
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            })
            if(moreSegment)
                return ( <>
                    <p> <IconWarningAlt filled color="colorYellow4" /> {t('moreSementSpecialCondition')} </p>
                </> );
        }
    }
    const newPress = () => {
        if (SpecialConditionDetail.newPress === true) {
            return <Checkbox
                defaultChecked
                id="newPress-checkbox-checked"
                label="New Press"
                disabled
            />
        }
    }

    const newEndUser = () => {
        if (SpecialConditionDetail.newEndUser === true) {
            return <Checkbox
                defaultChecked
                id="newEndUser-checkbox-checked"
                label="New End User"
                disabled
            />
        }
    }
    const [selectedTabIdDefault, setSelectedTabIdDefault] = useState(0);
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    let dates_data=datahistory.map(item=>item.monthYear).filter(onlyUnique);
    
    let data_ok=[];
    let count=0;
    dates_data.forEach(element => {
        let rows=datahistory.filter((item) => item.monthYear === element);
        data_ok.push({'name':moment(element).format("DD/MMM/YYYY")});
        rows.forEach(less => {
            data_ok[count][`${less.idPress}`]= parseInt(less.tpi_prom,10)
        });
        count++
    });
   data_ok=data_ok.reverse();
 const colors = [
    "#e34262",
    "#5ac18e",
    "#0ba2fe",
    "#f1b10a",
    "#004bff",
    "#a76fff",
    "#810b46",
    "#eea6e6",
    "#100b46",
    "#307060",
    "#a7ff55",
  ];
  class CustomizedAxisTick extends PureComponent {
    render() {
      const { x, y, payload } = this.props;
  
      return (
        <g transform={`translate(${x},${y})`}>
          <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">
            {payload.value}
          </text>
        </g>
      );
    }
  }
    return (
        
        <>     
            <Modal
                id="regular-modal"
                onClose={() => { setMoreSegment(false); onCloseSCDetailsModal(); }}
                show={onShowModal}
                css={{
                    '.vn-modal--content': {
                        width: "800px !important",
                        height:"690px !important",
                    },
                  }}
                title={t('scDetails')}
            >
                <Tabs
                    controlId="default"
                    onChangeTab={setSelectedTabIdDefault}
                    selectedTabId={selectedTabIdDefault}
                    tabs={[
                        {
                            id: 0, label: t('basicInf'), content: <div style={{ padding: '15px', height:"470px", "overflow-y": "scroll", marginBottom:"20px" }}>
                                <div>
                                    {morePressesFromTheSameSegment()/**Aqui hayq ue  verificar los segmentos */}
                                    {datedupliciti()}
                                </div>
                                <div>
                                    {newPress()}
                                </div>
                                <div>
                                    {newEndUser()}
                                </div>
                                <div>
                                    Special Condition Id: {SpecialConditionDetail.idSpecialCondition}
                                </div>
                                <div>
                                    Special condition Type: {SpecialConditionDetail.specialConditionType}
                                </div>
                                
                                <div>
                                    Channel: {SpecialConditionDetail.customerName}
                                </div>
                                <div>
                                    EndUser: {SpecialConditionDetail.endUserName}
                                </div>
                                <div>
                                    OPD #: {SpecialConditionDetail.opd}
                                </div>
                                <div>
                                    Created By: {SpecialConditionDetail.createdBy}
                                </div>
                                <div>
                                    Approved By: {SpecialConditionDetail.ApprovedBy}
                                </div>
                               
                                
                                <div>
                                    Press: {SpecialConditionDetail.idPress}
                                </div>
                                
                                <div>
                                    Start date:  {t('month' + ( new Date(SpecialConditionDetail.startDate).getMonth()+1).toString()) + "/"+ new Date(SpecialConditionDetail.startDate).getFullYear()}
                                </div>
                                <div>
                                    <TextBox
                                        id="effective-months"
                                        label="Effective Months"
                                        maxLength="2"
                                        value={effectiveMonths}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => {
                                            if (e != 0) {
                                                setEffectiveMonths(e);
                                                increaseEndDate(e);
                                            } else if (e == '0' || e == '00'){
                                                setEffectiveMonths(1);
                                                increaseEndDate(1);
                                            } else
                                                setEffectiveMonths(e);
                                            setNotesBoll(false);
                                        }
                                        }
                                    />
                                </div>
                                <div>
                                    End date: {t('month' + ( new Date(endDate).getMonth()+1).toString()) + "/"+ new Date(endDate).getFullYear()}
                                </div>
                                {specialConditionType()}
                                <div>
                                    Notes:
                                    <TextArea
                                    id="text-area-uncontrolled"
                                    //label="Notes"
                                    disabled={notesBoll}
                                    value={notes}
                                    placeholder={SpecialConditionDetail.notes}
                                    onChange={(e)=>{
                                        setNotes(e);
                                    }}
                                    />
                                </div>
                            </div>
                                
                        },
                        {
                            id: 1, 
                            label: t('additionalInf'), 
                            content: 
                                <div style={{ padding: '15px',  height:"470px","overflow-y": "scroll", marginBottom:"20px" }}>
                                    <SpecialConditionAdditionalInformation specialCondition={SpecialConditionDetail} />
                                    
                                </div>
                        },
                        {
                            id:2,
                            label: 'TPI',
                            content:
                                <div style={{ padding:'15px', height:"470px","overflow-y":'scroll', marginBottom:"20px" }}>
                                    <LineChart
                                        width={600}
                                        height={300}
                                        data={data_ok}
                                        margin={{ top: 5, right: 20, bottom: 5, left: 30 }}
                                        >
                                        {presses.map((item,index)=>{
                                            return(
                                                <Line
                                                    key={item}
                                                    type="monotone"
                                                    activeDot={{ r: 4 }}
                                                    dataKey={item}
                                                    name={item}
                                                    stroke={colors[index]}
                                                />
                                            );
                                        })}
                                        <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
                                        <XAxis dataKey="name" height={60} tick={<CustomizedAxisTick />}  />
                                        <YAxis />
                                        <Tooltip />
                                        <Legend />
                                    </LineChart>
                                </div>
                        }
                    ]}
                />
                <div>
                    <Button style={{marginRight: '5px'}} onClick={() => approveOrReject(true)} disabled={!effectiveMonths} >{t('approve')}</Button>
                    <Button style={{marginRight: '5px'}} onClick={() => approveOrReject(false)} appearance="secondary">{t('reject')}</Button>
                    {( (currentUser.idUser == "jocksan.walton.contreras@hp.com" || currentUser.idUser == "ruth.ramirez@hp.com")
                        && ( currentUser.idRole == 1 || currentUser.idRole == 8 ) && currentUser.idCountry == "MX" )?(
                        <Button 
                            leadingIcon={<IconDownload />}
                            onClick={() => {exportData();}}
                            appearance="tertiary"
                        >
                            {t('DownLoadLetter')}
                        </Button>
                    ):("")}
                </div>
            </Modal>

            </>
    );
}

export default SpecialConditionDetail;